import store from "@/Store/store"
import {DatasetBinder} from "@/Tasks/TaskView V2/components/TaskViewDetail/datasetBinder";
import {blankString, objectifyArr, getLongDate} from "@/codeFunctions";

// Task-level variables exposed to eval fields (mirrors the document template).
// Keep this list in sync with TASK_FIELDS in EvalTemplateEditor.vue.
export function taskFieldValues(task) {
    const t = task || {};
    return {
        date: getLongDate(new Date()),
        created: t.created ? getLongDate(new Date(t.created)) : '',
        title: t.title != null ? t.title : '',
        user: `${t.ownerName || ''} ${t.ownerSurname || ''}`.trim(),
        taskId: t.taskID != null ? t.taskID : '',
        folder: t.folderName != null ? t.folderName : '',
        subUser: `${t.subOwnerName || ''} ${t.subOwnerSurname || ''}`.trim()
    };
}

export function oldEvalConversion(evalString) {
    evalString = evalString.replace(/\\"/g,`"`)
      .replace(/&amp;/gm,`&`)
      .replace(/&lt;/gm,`<`)
      .replace(/&gt;/gm,`>`)
      .replace(/&nbsp;/gm,` `)
      .replaceAll('"<div contenteditable', '<div contenteditable')
      .replaceAll('</div>"', '</div>')
      .replaceAll("'<div contenteditable", '<div contenteditable')
      .replaceAll("</div>'", '</div>')

    const wfFieldsReg = /<div[^(<)]+f-W-V-\d+">[^>]+<\/div>/g
    const wfFieldIDExtractReg = /(?<=f-W-V-)\d+/g
    const wfFieldStrings = evalString.match(wfFieldsReg) || []

    for (const fieldStr of wfFieldStrings) {
        const fieldId = fieldStr.match(wfFieldIDExtractReg)?.at(-1)
        if (fieldId) {
            evalString = evalString.replace(fieldStr, "f-W-V-" + fieldId)
        } else {
            evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
        }
    }

    const dsFieldsReg = /<div[^(<)]+f-D-V-\d+-\d+">[^(<)]+<\/div>/g
    const dsFieldIDExtractDsSfIdReg = /(?<=f-D-V-)\d+/g
    const dsFieldIDExtractDsFIdReg = /(?<=-)\d+/g

    const dsFieldStrings = evalString.match(dsFieldsReg) || []

    for (const fieldStr of dsFieldStrings) {
        const selectFieldId = fieldStr.match(dsFieldIDExtractDsSfIdReg)?.at(-1)
        const fieldId = fieldStr.match(dsFieldIDExtractDsFIdReg)?.at(-1)

        if (fieldId) {
            evalString = evalString.replace(fieldStr, `f-D-V-${selectFieldId}-${fieldId}`)
        } else {
            evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
        }
    }

    return evalString.split('<div>').join('\n').split('</div>').join('').split('<br>').join(`\n`).split('&nbsp;').join(' ');
}

export class EvalBinder {
    task = null;
    localData = null;
    detailController = null;
    binder = null
    binderFields = []


    get userInfo() {
        return store.getters["userInfo/userInfo"];
    }

    constructor(localData, task, detailController, binder) {
        this.task = task;
        this.localData = localData;
        this.detailController = detailController;
        this.binder = binder
        this.binderFields = this.task.structure.fields
            .filter(field => field.fieldType === 22)
            .map(field => {
                return {
                    field: field,
                    status: 'init',
                    lastValue: field.value
                }
            })
        this.binder.emitter.on('loaded', () => {
            this.runForFields()
        })
    }

    runForFields() {
        for (const binderRef of this.binderFields) {
            try {
                this.runField(binderRef)
            } catch (e) {
                // console.log(e)
            }
        }
    }

    runField(binderRef, log = false) {
        const workflowRef = objectifyArr(this.task.structure.fields, "fieldID")

        const dsRef = Object.keys(this.binder.datasets).reduce((obj, memberId) => {
            obj[memberId] = objectifyArr(this.binder.datasets[memberId].fields, "datasetFieldID")
            return obj
        }, {})


        const lookup = typeof binderRef.field.lookup === 'string' ? JSON.parse(binderRef.field.lookup) : binderRef.field.lookup


        if (log)
            console.log({lookup})

        const evalStr = lookup.evalStr
            .replace(/\\"/g,`"`)
            .replace(/&amp;/gm,`&`)
            .replace(/&lt;/gm,`<`)
            .replace(/&gt;/gm,`>`)
            .replace(/&nbsp;/gm,` `)
        const refInfo = this.htmlToText(evalStr, true)

        if (log)
            console.log({refInfo})

        binderRef.status = 'Success'
        binderRef.wf = refInfo.fields.workflow.map((id) => {
            if (!workflowRef[id]) {
                if (log) console.log("Failed:", `Couldn't Find Workflow Field - ${id}`)
                binderRef.status = 'fail'
            }
            return workflowRef[id] ? workflowRef[id] : null
        })

        binderRef.ds = refInfo.fields.dataset.map((refObj) => {
            const memberID = workflowRef[refObj.dsSelectID] && workflowRef[refObj.dsSelectID].value ? workflowRef[refObj.dsSelectID].value : null
            if (!memberID) {
                if (log) console.log("Failed:", `Couldn't Find Dataset Select Field - ${refObj.dsSelectID}`)
                binderRef.status = 'fail'
                return null
            }
            const memberField = dsRef[memberID] && dsRef[memberID][refObj.dsFieldID] ? dsRef[memberID][refObj.dsFieldID] : null
            if (memberID && lookup.force) {
                if (log) console.log("Warning:", `Couldn't Find Dataset Field - MemberID: ${memberID}, Dataset Field ID: ${refObj.dsFieldID}`)
            } else if (!memberField) {
                if (log) console.log("Failed:", `Couldn't Find Dataset Field - MemberID: ${memberID}, Dataset Field ID: ${refObj.dsFieldID}`)
                binderRef.status = 'fail'
                return null
            }
            return {field:memberField, ref: refObj}
        })


        if (binderRef.status === 'fail') {
            // Couldn't resolve all referenced fields/datasets. Clear instead of
            // leaving the previously-evaluated value on screen (a populated field
            // would otherwise keep showing a stale result until a full reload).
            if (binderRef.field.value !== '')
                binderRef.field.value = ''
            return
        }

        // If Not Fail Then Build
        let str = refInfo.withTags.replace(/<div>|<\/div>|<br>|<\/br>/gm, '\n')
        binderRef.wf.forEach(wf => {

            if (lookup.force) {
                const reg = new RegExp(`\{\{W-${wf.fieldID}}}`, 'gm')
                str = str.replace(reg, wf.value ? `"${wf.value}"` : 'null')
            } else {
                if (wf.value === null) {
                    if (log) console.log("Failed:", `Couldn't Find A Value For Workflow Field ${wf.description}`)
                    binderRef.status = 'fail'
                } else {
                    const reg = new RegExp(`\{\{W-${wf.fieldID}}}`, 'gm')
                    str = str.replace(reg, `"${wf.value}"`)
                }
            }
        })

        binderRef.ds.forEach(ds => {
            if (lookup.force) {
                const reg = new RegExp(`\{\{D-${ds.ref.dsSelectID}-${ds.ref.dsFieldID}}}`, 'gm')
                str = str.replace(reg, !ds || !ds.field || ds.field.value === null ? 'null' : (ds.field.value ? `"${ds.field.value}"` : 'null'))
            } else {
                if (!ds || ds.field.value === null) {
                    if (log) console.log("Failed:", `Couldn't Find A Value For Dataset Field - Select Field: ${ds.ref.dsSelectID}, Dataset Field: ${ds.ref.dsFieldID}`)
                    binderRef.status = 'fail'
                } else {
                    const reg = new RegExp(`\{\{D-${ds.ref.dsSelectID}-${ds.ref.dsFieldID}}}`, 'gm')
                    str = str.replace(reg, `"${ds.field.value}"`)
                }
            }
        })

        // Task fields always resolve from the task object, so they never fail the eval.
        const taskValues = taskFieldValues(this.task)
        refInfo.fields.task.forEach(key => {
            const reg = new RegExp(`\\{\\{T-${key}}}`, 'gm')
            const val = taskValues[key]
            str = str.replace(reg, `"${String(val == null ? '' : val).replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n')}"`)
        })

        if (binderRef.status !== 'fail') {
            try {
                if (log)
                    console.log(str)
                const evaluation = (eval(str)).toString()
                if (binderRef.field.value !== evaluation) {
                    binderRef.field.value = evaluation
                }
            } catch (e) {
                if (log)
                    console.log(str, e)
                binderRef.status = 'fail'
            }
        }

        // A reference value was null or the eval threw during build — don't keep
        // a stale value, clear it so the field reflects the unresolved state.
        if (binderRef.status === 'fail' && binderRef.field.value !== '')
            binderRef.field.value = ''
    }

    htmlToText(html, includeReplaceValues = false) {
        let fields = {
            workflow: [],
            dataset: [],
            task: [],
        };

        // Step 1 Strip out Fields

        // Workflow Fields
        //`<div contenteditable="false" style="display: inline; border-radius: 3px" class="pa-1 white--text caption red" id="f-W-V-${item.id}">${item.description}</div>`
        let tWkfSplit = oldEvalConversion(html)
        //   .split(`<div contenteditable="false" style="display: inline; border-radius: 3px" class="pa-1 white--text caption red" id="f-W`)
        // tWkfSplit = tWkfSplit.map(part => {
        //     // Check if Valid Tag
        //     if (!blankString(part) && part.length > 3 && part.substr(0,3) === '-V-') {
        //         let fieldName = part.substring(3, part.indexOf('"'));
        //         let postTag = part.substring(part.indexOf('</div>') + 6, part.length);
        //         fields.workflow.push(parseInt(fieldName));
        //         if (includeReplaceValues) {
        //             postTag = `{{W-${fieldName}}}` + postTag;
        //         }
        //         return postTag
        //     } else {
        //         return part
        //     }
        // })

        for (const fieldRef of tWkfSplit.match(/f-W-V-\d+/g) || []) {
            const fieldId = fieldRef.match(/\d+/g)?.at(-1)
            fields.workflow.push(parseInt(fieldId))
            if (includeReplaceValues) {
                tWkfSplit = tWkfSplit.replaceAll(fieldRef, `{{W-${fieldId}}}`)
            }
        }





        // Dataset Fields
        //`<div contenteditable="false" style="display: inline; border-radius: 3px" class="pa-1 white--text caption blue" id="f-D-V-1-5">Some Description</div>`
        let tDSSplit = tWkfSplit
        //   .join('').split(`<div contenteditable="false" style="display: inline; border-radius: 3px" class="pa-1 white--text caption blue" id="f-D`);
        // tDSSplit = tDSSplit.map(part => {
        //     // Check if Valid Tag
        //     if (!blankString(part) && part.length > 3 && part.substr(0,3) === '-V-') {
        //         let fieldName = part.substring(3, part.indexOf('"'));
        //
        //         let postTag = part.substring(part.indexOf('</div>') + 6, part.length);
        //
        //         fields.dataset.push({
        //             dsSelectID: parseInt(fieldName.substring(0, fieldName.indexOf('-'))),
        //             dsFieldID: parseInt(fieldName.substring(fieldName.indexOf('-') + 1, fieldName.length))
        //         });
        //
        //         if (includeReplaceValues) {
        //             postTag = `{{D-${fieldName}}}` + postTag;
        //         }
        //         return postTag
        //     } else {
        //         return part
        //     }
        // })

        // const dsFieldsReg = /f-D-V-\d+-\d+/g
        // const dsFieldIDExtractDsSfIdReg = /(?<=f-D-V-)\d+/g
        // const dsFieldIDExtractDsFIdReg = /(?<=-)\d+/g
        //
        // const dsFieldStrings = evalString.match(dsFieldsReg) || []
        //
        // for (const fieldStr of dsFieldStrings) {
        //
        //     const selectFieldId = fieldStr.match(dsFieldIDExtractDsSfIdReg)?.at(-1)
        //
        //     const workflowSelectField = workflowFields.find(v => v.id.toString() === selectFieldId)
        //     const dataset = datasetFields.find(v => v.id.toString() === workflowSelectField?.config?.dataset)
        //
        //     const datasetFieldId = fieldStr.match(dsFieldIDExtractDsFIdReg)?.at(-1)
        //
        //     const datasetField = dataset?.fields.find(v => v.id.toString() === datasetFieldId)
        //
        //     if (workflowSelectField && datasetField) {
        //         evalString = evalString.replace(fieldStr, `${replaceFieldName(workflowSelectField.description)}.${replaceFieldName(datasetField.description)}_${datasetField.id}`)
        //     } else {
        //         evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
        //     }
        // }

        for (const fieldRef of tDSSplit.match(/f-D-V-\d+-\d+/g) || []) {
            const dsSelectID = fieldRef.match(/(?<=f-D-V-)\d+/g)?.at(-1)
            const dsFieldID = fieldRef.match(/(?<=-)\d+/g)?.at(-1)


            fields.dataset.push({
                dsSelectID: parseInt(dsSelectID),
                dsFieldID: parseInt(dsFieldID)
            });

            if (includeReplaceValues) {
                tDSSplit = tDSSplit.replaceAll(fieldRef, `{{D-${dsSelectID}-${dsFieldID}}}`)
            }

        }

        // let tBeforeTagReplace = tDSSplit.join('');
        //
        // //Split Out Tags
        // let tAfterTags = tDSSplit.join('').split('<div>').join('\n').split('</div>').join('').split('<br>').join(`\n`).split('&nbsp;').join(' ');

        // Task Fields — f-T-V-{key} (e.g. f-T-V-title). Always resolvable from the task.
        for (const fieldRef of tDSSplit.match(/f-T-V-[A-Za-z]+/g) || []) {
            const key = fieldRef.replace('f-T-V-', '')
            fields.task.push(key)
            if (includeReplaceValues) {
                tDSSplit = tDSSplit.replaceAll(fieldRef, `{{T-${key}}}`)
            }
        }

        return {
            fields: fields,
            withTags: tDSSplit,
            afterTags: tDSSplit
        }
    }




}